module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-2021-2.3dfa97f1.jpg";